import { getStakeholders } from '@/selectors/merchant/recollection';
import withStakeholderLogic from '../withStakeholderLogic/withStakeholderLogic';

export const withRecollectionStakeholderLogic = (cap, { capabilityCallback, extraProps } = {}) =>
  withStakeholderLogic(cap, {
    capabilityCallback,
    extraProps,
    stakeholdersSelector: getStakeholders,
  });
